module.exports = "td {\r\n    text-align: left;\r\n}\r\n\r\n:host /deep/ .dx-icon {\r\n    width:40px;\r\n    height: 55px;\r\n    margin-right:26px;\r\n}"